import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMyDataQuery } from '@/generated/graphql';
import { useHasFeature } from '@/lib/useHasFeature';
import { SOCIAL_PUBLISHING_FEATURE } from '@/lib/publishing/socialPublishingFeature';
import { useHomeRoute } from '@/hooks/use-home-route';

const SocialPublishingRoute = ({ children }: { children: ReactNode }) => {
  const { loading } = useMyDataQuery();
  const hasSocialPublishing = useHasFeature(SOCIAL_PUBLISHING_FEATURE);
  const { route: homeRoute } = useHomeRoute();

  if (loading) return null;

  if (!hasSocialPublishing) {
    return <Navigate to={homeRoute} replace />;
  }

  return <>{children}</>;
};

export default SocialPublishingRoute;
